export function buildAbsoluteLink(href: string): any {
    if (href.startsWith('http://') || href.startsWith('https://')) {
        return href;
    }

    // Both sides are normalised: NEXT_PUBLIC_HOST carries a trailing slash in some
    // environments and not in others, and `https://host//club/x` is a different
    // path from `/club/x` — which is how these links broke on the club subdomains.
    const baseUrl = (process.env.NEXT_PUBLIC_HOST || '').replace(/\/+$/, '');

    return `${baseUrl}/${href.replace(/^\//, '')}`;
}
